import React from "react";
import { ModalHeader } from "reactstrap";

const TipModalHeader = ({ activeStep, toggleModal, color }) => {
  const titles = {
    1: "Add Tip",
    2: "Choose Payment Method",
  };

  return (
    <ModalHeader
      toggle={toggleModal}
      className="d-flex justify-content-between align-items-center"
      style={{
        borderBottom: `1px solid ${color}`,
        fontWeight: 600,
        fontSize: "20px",
        color: color,
      }}
    >
      {titles[activeStep] || "Add Tip"}
    </ModalHeader>
  );
};

export default TipModalHeader;
